class NewsletterModal extends HTMLElement {
  constructor() {
    super();

    //Con esto sacamos el objeto con los parámetros del modal
    this.configs = JSON.parse(this.getAttribute("configs"));

    //Seleccionamos overlay, modal, y boton de cierre
    this.overlay = this.querySelector(".custom-overlay");
    this.modalContent = this.querySelector(".custom-modal-content");
    this.closeButton = this.querySelector(".custom-close-button");

    // Abrir el modal al hacer clic en enlaces con href="#popup"
    document.querySelectorAll('a[href="#popup"]').forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.showModal();
      });
    });

    //En caso de que open_auto == true entonces el popup se abrirá automáticamente apenas se entre a la página
    //cada {{ time_delay }} segundos
    if (this.configs.open_auto) {
      setTimeout(() => {
        this.showModal();
      }, this.configs.time_delay * 1000); // Mostrar el modal después del tiempo de delay
    }

    // Cerrar el modal al hacer clic en el overlay o en el botón de cierre
    this.overlay.addEventListener("click", () => this.hideModal());
    this.closeButton.addEventListener("click", () => this.hideModal());


    document.addEventListener("updatePopupHref", () => { 
      document.querySelectorAll('a[href="#popup"]').forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          this.showModal();
        });
      });
    });
  }

  showModal() {
    this.overlay.classList.remove("hidden");
    this.modalContent.classList.remove("hidden");
    // Asegurarse de ocultar el modal después de la transición
    setTimeout(() => {
      this.overlay.classList.add("show");
      this.modalContent.classList.add("show");
    }, 100); // Tiempo de duración de la transición
  }

  hideModal() {
    this.overlay.classList.remove("show");
    this.modalContent.classList.remove("show");
    // Asegurarse de ocultar el modal después de la transición
    setTimeout(() => {
      this.overlay.classList.add("hidden");
      this.modalContent.classList.add("hidden");
    }, 100); // Tiempo de duración de la transición
  }
}

customElements.define("sys-newsletter", NewsletterModal);
